import React from "react";
import {BsLinkedin} from "react-icons/bs";
import {FaGithub} from "react-icons/fa";
import {BsFacebook} from "react-icons/bs";

const HeaderSocials = ()=>{
    return (
        <div className="header__socials">

            <a href="https://www.linkedin.com/in/dhirendra-kumar-jaiswal-949b3a230/" target="_blank"><BsLinkedin /></a>

            <a href="https://github.com/dk-jaiswal-77" target="_blank"><FaGithub /></a>

            <a href="https://www.facebook.com/profile.php?id=100072096787997" target="_blank"><BsFacebook /></a>
            
        </div>
    );
}

export default HeaderSocials; 